export const wrhLangCn = {
         ticketWrh: {
           storeName: "便利店名称",
           selectStore: "请选择便利店名",
           waitApproval: "待审批",
           alApproval: "已审批",
           appliedPanel: "已申请",
           look: "查看",
           approvalComments: "相关审批意见",
           currentApproval: "当前节点处理人",
           time: "时间",
           approvalPeople: "审批人",
           approvalComment: "审批意见",
           waitOrder: "待处理",
           orderstatus: "订单状态",
           loanamount: "放款金额",
           partiallyCompleted: "部分完成",
           normalStatus: "正常",
           noNormalStatus: "非正常",
           userName: "用户名",
           orderInvalidTime: "订单失效时间",
           dial: "拨打",
           Submit: "完成",
           IsGP0: "非地推",
           IsGP1: "地推",
           showNumber: "号码",
           To: '至'
         },
         tipsWrh: {
           calcFee: "计算服务费",
           calcFeeTip:
             "(注意：输入还款金额，点击计算服务费即可展示服务费及服务费IVA)",
           fee: "手续费",
           feeIVA: "手续费 IVA",
           currentPersonalTime: "当前个人剩余减免次数",
           currentGroupTime: "当前小组剩余减免次数",
           currentRemainingDeduction: "当前剩余个人可申请减免总额度",
           makeLoan: "放款",
           continueFollow: "继续跟进",
           userBirthday: "用户出生日期",
           enterUserBirthday: "请填写用户的出生日期",
           opreSuccess: "操作成功",
           enterMark: "其他（请填写备注）",
           userAndOrder: "用户&订单信息",
           productInfo: "产品信息",
           product: "产品",
           diaOperation: "拨打操作",
           pleaseResult: "请选择结果",
           previewImage: "我是图片，点击可预览",
           selectBrithday: "请选择生日",
           enterTelephone: "请输入手机号码",
           enterIdCard: "请输入身份证INE的ID",
           enterCurp: "请输入CURP号",
           enterStaffNum: "请输入员工工号",
           enterChilNum: "请输入家中儿童数量",
           enterFamilyAddress: "请输入家庭住址",
           enterPhone: "请输入电话号码",
           enterCompanyName: "请输入公司名称",
           enterCompanyPosition: "请输入公司岗位",
           enterCompanyTime: "请输入在职时间",
           enterRewardMoney: "请输入金额",
           editPeople: "编辑人员信息",
           addPeople: "新增人员信息",
           enterRFC: "请输入RFC",
           noNormal: "非正式",
           admin: "Admin",
           editBaseInfo: "编辑个人资料",
           enterStatus: "请选择当前状态",
           recordTitle: "入离职记录",
           clickAdd: "点击添加员工基础信息...",
           workRecord: "入离职记录",
           enterChooseTime: "请选择时间",
           tip: "提示",
           cumulativeReward: "累计奖励",
           cumulativePunish: "累计惩罚",
           cumulativeLtter: "收到警告信",
           Times: "次",
           seal: "封",
         },
         menuWrh: {
           reduceApproval: "减免审批",
           teleMarket: "电销",
           teleMarketRecord: "电销记录",
         },
         tableWrh: {
           reduceType: "减免类型",
           applyPeople: "申请人",
           approvalResult: "审批结果",
           reduceResult: "减免结果",
           approvalDetail: "审批详情",
           reduceAmount: "减免金额",
           Operador: "电销人员",
           dialTime: "拨打时间",
           whentherDial: "是否拨通",
           dialSituation: "拨通/未拨通情况",
           remark: "备注",
         },
         formWrh: {
           birthDay: "生日",
           cardId: "身份证INE的ID",
           cardCURP: "CURP号",
           cardPhoto: "身份证照片",
           staffNum: "员工工号",
           marryStatus: "婚姻状态",
           chilNum: "家中儿童数量",
           familyAddress: "家庭住址",
           addressProof: "居住地址证明",
           familyContact: "联系人",
           familyRealtion: "关系",
           familyTelephone: "联系电话",
           companyName: "公司名称",
           companyPosition: "工作岗位",
           companyTime: "在职时间",
           punishType: "奖惩类别",
           punishMoney: "涉及金额 (MXN)",
           questionType: "惩罚形式",
           Type: "类型",
           punishDesc: "描述",
           //选择项label
           man: "男",
           woman: "女",
           onJob: "在职",
           quit: "离职",
           married: "已婚",
           unmarried: "离异",
           single: "单身",
           cohabitation: "同居",
           parent: "父母",
           couple: "夫妻",
           children: "儿女",
           friend: "朋友",
           reward: "奖励",
           punish: "惩罚",
           complianceIssues: "合规问题",
           businessIssues: "业务问题",
           disciplinaryIssues: "纪律问题",
           oralWarning: "口头警告",
           commitLetter: "承诺书",
           warningLetter: "警告信",
           RFC: "RFC",
           personalInfo: "个人档案",
           identityInfo: "身份信息",
           familyInfo: "家庭背景",
           workInfo: "工作档案",
           occupancyInfo: "工作经历",
           rewardInfo: "奖惩记录",
           staffStatusInfo: "员工状态",
           upload: "上传",
           status: "状态",
           leaveTime: "离职时间",
           enterTime: "入职时间",
           leaveReason: "离职原因",
         },
       };
